import { useLocalSearchParams } from 'expo-router';
import { useMemo } from 'react';

import { firstOAuthSearchParam } from '../oauth';
import type { AuthNavigationParams } from '../types';

/** Router params preserved across sign-in, verify, and sign-up (including OAuth `redirect_uri` / `state`). */
export function useAuthNavigationParams(): AuthNavigationParams {
  const params = useLocalSearchParams<{
    loginJwt?: string;
    redirect_uri?: string | string[];
    state?: string | string[];
  }>();

  return useMemo(() => {
    const navigationParams: AuthNavigationParams = {};
    if (params.loginJwt) {
      navigationParams.loginJwt = params.loginJwt;
    }
    const redirectUri = firstOAuthSearchParam(params.redirect_uri);
    if (redirectUri) {
      navigationParams.redirect_uri = redirectUri;
    }
    const state = firstOAuthSearchParam(params.state);
    if (state) {
      navigationParams.state = state;
    }
    return navigationParams;
  }, [params.loginJwt, params.redirect_uri, params.state]);
}
